import React from 'react';
import UsersStatus from './UsersStatus';
import { TeamFilter } from './TeamFilter';
import { MilestoneSwitch } from '../common/MilestoneSwitch';
import { useDispatch, useSelector } from 'react-redux';
import { actionFetchIssues } from '../../lib/actions';
import { useMilestone } from '../../lib/hooks';
import Icon from '../ds/Icon';

const Header = () => {

    const milestone = useMilestone();
    const dispatch = useDispatch();

    const { userInfo, fetchInProgeress, sidebarOpen } = useSelector(st => ({
        userInfo: st.userInfo,
        sidebarOpen: st.uiState.sidebarOpen,
        fetchInProgeress: st.tickets.ticketList === null
    }));

    const toggleSidebar = (e) => {
        e.preventDefault();
        dispatch({ type: 'toggle-sidebar' });
    };

    return (
        <header className="app-topbar">
            <button
                type="button"
                onClick={toggleSidebar}
                className="ds-btn is-ghost is-icon app-topbar__menu"
                aria-label="Open navigation menu"
                aria-expanded={sidebarOpen}
            >
                <Icon name="menu" />
            </button>

            <div className="app-topbar__spacer" />

            <div className="app-topbar__tools">
                <UsersStatus user={userInfo} />
                <TeamFilter />
                <button
                    type="button"
                    disabled={fetchInProgeress}
                    onClick={() => dispatch(actionFetchIssues(milestone, 'refresh'))}
                    className="ds-btn is-ghost is-icon"
                    aria-label="Refresh data"
                    title="Refresh data"
                >
                    <Icon name="refresh" />
                </button>
                <MilestoneSwitch />
            </div>
        </header>
    );
};

export default Header;
